import CommonDelete from "@/components/CommonUi/CommonDelete";
import CreateDrawer from "@/components/CommonUi/CreateDrawer";
import TableComponent from "@/components/CommonUi/TableComponent";
import UserPrivateComponent from "@/components/PrivacyComponent/UserPrivateComponent";
import { loadAllContactPaginated } from "@/redux/rtk/features/CRM/contact/contactSlice";
import { apiSlice } from "@/redux/rtk/features/apiSlice/apiSlice";
import { useGetLeadSourcesQuery } from "@/redux/rtk/features/leadSource/leadSourceApi";

import Modal from "@/UI/Modal";
import { useEffect, useState } from "react";
import { CiEdit } from "react-icons/ci";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import AddLeadSource from "./AddLeadSource";
import UpdateLeadSource from "./UpdateLeadSource";

export default function GetAllLeadSource() {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [pageConfig, setPageConfig] = useState({
    page: 1,
    count: 10,
  });
  const { data, isLoading } = useGetLeadSourcesQuery(pageConfig);
  const [edit, setEdit] = useState(null);

  const columns = [
    {
      title: t("common.id"),
      dataIndex: "id",
      key: "id",
    },
    {
      title: t("leadSource.name"),
      key: "name",
      dataIndex: "name",
    },

    {
      title: "",
      key: "action",
      render: (item) => [
        {
          label: (
            <span className="cursor-pointer" onClick={() => setEdit(item)}>
              <button className="flex justify-center items-center gap-2 rounded">
                <CiEdit /> {t("common.edit")}
              </button>
            </span>
          ),
          key: "edit",
        },
        {
          label: (
            <CommonDelete
              id={item.id}
              title={t("common.delete")}
              permission={"delete-leadSource"}
              deleteThunk={apiSlice.endpoints.deleteLeadSource.initiate}
              query={pageConfig}
              className="bg-white text-black"
            />
          ),
          key: "delete",
        },
      ],
    },
  ];

  useEffect(() => {
    dispatch(loadAllContactPaginated(pageConfig));
  }, [dispatch, pageConfig]);

  return (
    <UserPrivateComponent permission={"readAll-leadSource"}>
      <TableComponent
        list={data}
        columns={columns}
        loading={isLoading}
        setPageConfig={setPageConfig}
        title={t("leadSource.leadSourceList")}
        componentTitle={t("leadSource.title")}
        extra={
          <CreateDrawer
            permission={"create-leadSource"}
            title={t("leadSource.createLeadSource")}
            width={30}>
            <AddLeadSource />
          </CreateDrawer>
        }
      />
      <Modal
        open={edit}
        onClose={() => setEdit(false)}
        className=" px-5 "
        title={t("leadSource.editLeadSource")}>
        <UpdateLeadSource data={edit} onClose={() => setEdit(false)} />
      </Modal>
    </UserPrivateComponent>
  );
}
